var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ETH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ethereum"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ETH"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1",
    fill: "#F0F0F0",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(16.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#343434",
    points: "11.8713911 0 11.6120894 0.865707434 11.6120894 25.9866235 11.8713911 26.2408681 23.7428657 19.3481966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#8C8C8C",
    points: "11.8714746 0 0 19.3481966 11.8714746 26.2408681 11.8714746 14.0479712"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#3C3C3B",
    points: "11.8713911 28.448659 11.7252729 28.6237141 11.7252729 37.5723041 11.8713911 37.9914887 23.7499165 21.5594504"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#8C8C8C",
    points: "11.8714746 37.9913612 11.8714746 28.4486225 0 21.5593228"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#141414",
    points: "11.8713911 26.2407496 23.7426802 19.3481693 11.8713911 14.048035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#393939",
    points: "8.34960938e-05 19.3481784 11.8713726 26.2408499 11.8713726 14.0480441"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img-2.b63ceba6038151f0b2a4d67f3fd1914e.svg";
export { ForwardRef as ReactComponent };